__webpack_require__.p = "https://vquiz-fe.vedantu.com/_next/";